import UkisWordmark from '@/assets/ukisai-wordmark.svg?react';

export default function WaterMark() {
  return (
    <div className="watermark flex w-full items-center justify-center py-1">
      <a
        href="https://ukisai.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Built by UkisAI"
        className="mx-auto inline-flex w-fit items-center justify-center gap-1.5 text-[9px] font-semibold text-foreground no-underline transition-opacity duration-150 hover:opacity-75"
      >
        <span>Built by</span>
        <UkisWordmark
          aria-hidden="true"
          focusable="false"
          className="h-[16px] w-[51px] shrink-0 text-foreground [&>path]:fill-current"
        />
      </a>
    </div>
  );
}
